import styled, { css } from "styled-components";

import Props from "./props";

const Icon = styled.i<Props>`
    font-family: "goal-icons" !important;
    speak: none;
    font-style: normal;
    font-weight: normal;
    font-variant: normal;
    text-transform: none;
    line-height: 1;
    ${({ name }) => {
        switch (name) {
            case "university":
                return css`
                    &:before {
                        content: "\\e900";
                    }
                `;
            case "briefcase":
                return css`
                    &:before {
                        content: "\\e901";
                    }
                `;
            case "employee":
                return css`
                    &:before {
                        content: "\\e902";
                    }
                `;
            case "back":
                return css`
                    &:before {
                        content: "\\e903";
                    }
                `;
            case "search":
                return css`
                    &:before {
                        content: "\\e904";
                    }
                `;
        }
    }}
`;

export default Icon;
